import React from 'react';
import { IStore } from "../../redux/reducers";
import { useSelector } from "react-redux";
import { View } from 'react-native';
import { isNative } from '../../utils/utils'
import CustomAlertDialog from '../CustomAlertDialog';
import { Button, HStack } from 'native-base';
import MaterialIconByName from '../MaterialIconByName';
import { getText } from 'src/utils/i18n';
import { isLightboxFeatureEnabled } from 'src/utils/grainFeatureUtils';

export default function InfoStatusBar({ navigation }: { navigation: any }) {

    const grainTypes = useSelector((store: IStore) => store.user?.userProfile?.response?.grains);
    const grainId: string | undefined = useSelector((store: IStore) => store.grainType.grainId);
    const lightboxEnabled = useSelector((store: IStore) =>
        isLightboxFeatureEnabled(store.user?.userProfile?.response?.settings)
    );
    const rpiStatus = useSelector((store: IStore) => store.bluetooth.rpiStatus);
    const rpiConnected = useSelector((store: IStore) => store.bluetooth.connectedRpi.connectedDevice);

    const [grainName, setGrainName] = React.useState<string | undefined>(undefined);
    const [visible, setVisible] = React.useState(false);

    const showDialog = () => setVisible(true);

    const hideDialog = () => setVisible(false);


    const isWifiConnected = () => {
        if (rpiStatus === undefined || rpiStatus.status === undefined) {
            return false;
        }

        return rpiStatus.status.wifiStatus === "CONNECTED";
    }

    React.useEffect(() => {
        if (grainTypes) {
            const grain = grainTypes.find((item) => item.grainId === grainId);
            if (grain) {
                setGrainName(grain.name);
            }
        }
    }, [grainTypes, grainId]);

    const navigateToChooseGrainProfile = () => {
        const parentNav = navigation?.getParent?.();
        if (parentNav && typeof parentNav.navigate === 'function') {
            parentNav.navigate('ChooseGrainProfile', {});
            return;
        }
        navigation?.navigate?.('ChooseGrainProfile', {});
    };

    return (
        <View>
            <CustomAlertDialog
                title='IoT device not connected'
                description='GRAMs IoT device is not connected via bluetooth. Click continue to configure it.'
                cancelText='Cancel'
                confirmText='Continue'
                isOpen={visible}
                onCancelClicked={hideDialog}
                onConfirmClicked={() => {
                    hideDialog();
                    navigation.push('ConnectToRpi', {
                        returnBackTo: 'Home',
                    })
                }}
            />
            <HStack style={{
                padding: 4,
                flexDirection: 'row',
                alignSelf: 'center',
                justifyContent: 'center',
                marginLeft: 12,
                marginRight: 12,
                width: '100%',
            }} space={2}>
                {
                    isNative() && !lightboxEnabled && <Button variant='outline'
                        colorScheme={rpiConnected !== undefined ? "green" : "red"}
                        style={{
                            borderColor: rpiConnected !== undefined ? "green" : "red",
                            width: 100,
                            height: 42,
                        }}
                        leftIcon={<MaterialIconByName name={rpiConnected !== undefined ? "bluetooth-connect" : "bluetooth-off"} />}
                        onPress={() =>
                            navigation.navigate('ConnectToRpi', {
                                returnBackTo: 'Home',
                            })
                        } >{getText('blueTooth')}</Button>
                }
                {
                    isNative() && !lightboxEnabled && <Button variant='outline'
                        colorScheme={isWifiConnected() ? "green" : "red"}
                        style={{ borderColor: isWifiConnected() ? "green" : "red", height: 42, width: 100 }}
                        leftIcon={<MaterialIconByName name={isWifiConnected() ? "wifi" : "wifi-off"} />}
                        onPress={() => {
                            if (rpiConnected !== undefined) {
                                navigation.navigate('ConfigureRpiWifi', {
                                    returnBackTo: 'Home',
                                })
                            } else {
                                showDialog()
                            }
                        }
                        } >{getText('wifi')}</Button>
                }

                <Button variant='outline'
                    style={{
                        borderColor: "green",
                        height: 42,
                        width: 110,
                    }}
                    colorScheme={"green"}
                    leftIcon={<MaterialIconByName name="barley" />}
                    onPress={navigateToChooseGrainProfile}
                >{grainName}</Button>
            </HStack>
        </View>
    );
};
